module.exports = __webpack_public_path__ + "img/ico-doc.6aa1bece.jpg";